export enum MassUpdateAction {
    ADD = 'ADD',
    REPLACE = 'REPLACE',
    CLEAR = 'CLEAR',
    FIND_AND_REMOVE = 'FIND_AND_REMOVE',
}

export type Selection = { primaryKeys: string[]; itemsQuery: unknown };

/** Matches ApiConstants.ERROR_CODE_ITEMS_MASS_UPDATE_ALL_ITEMS_DISABLED (LAX-10076 / LAX-10087). */
export const MASS_UPDATE_ALL_ITEMS_DISABLED_ERROR_CODE = 1320;

export type MassUpdateRequestPayload = {
    selectionId: string;
    itemData: object;
    force?: boolean;
};

export type MassUpdateAttributeValue = {
    action?: MassUpdateAction | string;
    value?: unknown;
};

export const isQueryBasedSelection = (
    primaryKeys: string[] | undefined,
): boolean => !(primaryKeys instanceof Array);
